module.exports = __webpack_public_path__ + "img/hr-copper-ore.2fb51a4d.png";